import { assetFilenameSpace } from '../../consts';
import { GalleryItem } from '../classes/gallery-item.class';

export const getAssetSectionHeight = (items: GalleryItem[], spacing: number, show_filenames = false) => {
  if (!items.length) return 0;
  return (
    items.reduce((r, item) => Math.max(item.dimensions.y + item.dimensions.height, r), 0) +
    spacing +
    (show_filenames ? assetFilenameSpace : 0)
  );
};
